<template>
  <div class="container">
    <h2>{{ page.Title }}</h2>
    <div v-if="page.Content" v-html="page.Content"></div>
    <div class="row">
      <div class="col-md-6">
        <DoSelect
          v-model="page.Questions[0].Value"
          :value="page.Questions[0].Value"
          :id="page.Questions[0].QID"
          :config="page.Questions[0].Config"
          :options="page.Questions[0].Options"
          @getNewData="makeArray"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <!-- bound by subscriptiondate - must not exceed subscriptiondate -->

        <DoLeaveOfAbsenceStartDate
          v-model="page.Questions[1].Value"
          :value="page.Questions[1].Value"
          :id="page.Questions[1].QID"
          :config="page.Questions[1].Config"
          @setChangeDate="setChangeDate"
        />
      </div>
      <div class="col-md-6">
        <DoDate
          v-model="page.Questions[2].Value"
          :value="page.Questions[2].Value"
          :id="page.Questions[2].QID"
          :config="page.Questions[2].Config"
          @setChangeDate="setChangeDate"
        />
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    inject: {
      $validator: '$validator',
    },
    props: {
      page: {
        type: Object,
        required: true,
      },
    },
    methods: {
      makeArray() {},
      setChangeDate(data, val) {
        let filtered = this.page.Questions.filter(
          (item) => item.QID == data.key
        );
        filtered[0].Config.date[data.val] = val;
      },
    },
  };
</script>
